module.exports = __webpack_public_path__ + "img/process-img-3.f27abab5.png";